import {
  TRbacMatrix,
  TRole,
  IRbac,
} from "../../apis/rbac/rbac.interfaces";
import { RBAC_PERMISSION_STRUCTURE } from "../../apis/rbac/rbac.constants";
import {
  createEmptyPermissions,
  clonePermissions,
} from "../../utils/rbacHelpers";

const SAMPLE_INSTITUTE_ID = "1";

const sampleRoles: TRole[] = [
  {
    id: "role-admin",
    name: "Administrator",
    description: "Full access to all modules",
    instituteId: SAMPLE_INSTITUTE_ID,
  },
  {
    id: "role-viewer",
    name: "Viewer",
    description: "Read-only access",
    instituteId: SAMPLE_INSTITUTE_ID,
  },
];

function createReadOnlyPermissions(structure: IRbac): IRbac {
  const result: IRbac = {};
  for (const [module, submodules] of Object.entries(structure)) {
    result[module] = {};
    for (const [submodule] of Object.entries(submodules)) {
      result[module][submodule] = {
        read: true,
        write: false,
        delete: false,
      };
    }
  }
  return result;
}

/** Mutable map: roleId -> IRbac permissions. Used when VITE_APP_WITH_MOCK_DATA=true */
export const rolePermissionsMap: Record<string, IRbac> = {
  "role-admin": clonePermissions(RBAC_PERMISSION_STRUCTURE),
  "role-viewer": createReadOnlyPermissions(RBAC_PERMISSION_STRUCTURE),
};

export const rbacMatrixMock: TRbacMatrix = {
  roles: [...sampleRoles],
  permissions: [],
  rolePermissions: [],
};

/** Initialize permissions for a newly created role (all disabled). Call from createRole mock. */
export function initRolePermissionsForNewRole(roleId: string): void {
  rolePermissionsMap[roleId] =
    createEmptyPermissions(RBAC_PERMISSION_STRUCTURE);
}
